var Curriculog = Curriculog || {};

Curriculog.SupportFormDialog = (function ($, _, Backbone, SupportFormDialog) {

	/*
		Although this is called "Dialog" and stored in js/views/Dialog, 
		it doesn't extend the Dialog here, but in the click event, which is 
		located in javascript.js because it must be available throughout 
		the user side of the app. 
	*/

	SupportFormDialog = Backbone.View.extend({
		el: function() {
			return $('#support-form');
		},

		events: {},

		initialize: function(options) {
			this.getFormValues();
			this.render();
		},

		render: function() {
			var html = nunjucks.render('Dialog/supportForm.html');
			this.setElement(html);
		},

		getFormValues: function() {
			var rowInputs = $('#support-form').find('input, textarea').toArray();
			this.model = rowInputs.reduce(function (a, b) {
				var name = $(b).attr('name').replace('support-','');
				a[name] = $(b).val();
				return a;
			}, {});
		},


		isNotEmpty: function(element){
			return Boolean($(element).val().trim().length);
		},

		validateForm: function() {
			$.validity.clear();
			$.validity.start();

			// Note: We need to reference form fields this way
			// because validity uses a reduction that binds the
			// DOM object selection in a way that clear() does not
			// properly clear it. If the user clicks the support form
			// twice in the same session, the second time validity will
			// not run.
			var $question = this.$el.find('#support-question');
			var $details = this.$el.find('#support-details');
			var $name = this.$el.find('#support-name');
			var $email = this.$el.find('#support-email');

			$question.require().assert(this.isNotEmpty, "This field is required");
			$details.require().assert(this.isNotEmpty, "This field is required");
			$name.require().assert(this.isNotEmpty, "This field is required");
			$email.require().assert(this.isNotEmpty, "This field is required").match('email');

			return $.validity.end().valid;
		},

		submitForm: function (dialog) {
			var valid = true;
			this.getFormValues();
			var t = this;
			valid = this.validateForm();
			if (valid) {
				$.ajax({
					type: 'PUT',
					url: '/rpc/support/send',
					contentType: 'application/json',
					data: JSON.stringify({support_request: this.model}),
					beforeSend: function() {
						t.addMask();
					},
					complete: function() {
						$.validity.clear();
						console.log($.validity.valid);
						t.removeMask();
					},
					success: function() {
						t.resetForm();
						dialog.close();
					},
					error: function() {
						var errorMsg = 'There was an error submitting your support request. ' +
							'Please try to submit your request again.' +
							'<br><br>This problem has been reported.';

						$('#growls').notify('create', 'warning-template', {
							title: 'Warning',
							text: errorMsg
						},{
							expires: false
						});
					}
				});
			}
		},

		resetForm: function() {
			this.model = {
				question: '',
				details: '',
				url: '',
				name: '',
				email: ''
			};
			var rowInputs = $('#support-form').find('input, textarea').val('');
		},

		addMask: function() {
			$('#support-form').mask('Sending Your Request...');
		},

		removeMask: function() {
			$('#support-form').unmask();
		}
	});

	return SupportFormDialog;

})($, _, Backbone, Curriculog.SupportFormDialog || {});



